import { useEffect, useState } from "react";

export interface UseCompactHeaderResult {
  showCompactHeader: boolean;
  headerOpacity: number;
  scrollProgress: number;
  showProductInfo: boolean;
}

const FADE_START = 100;
const FADE_COMPLETE = 300;

export function useCompactHeader(): UseCompactHeaderResult {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollProgress =
    scrollY <= FADE_START
      ? 0
      : scrollY >= FADE_COMPLETE
      ? 1
      : (scrollY - FADE_START) / (FADE_COMPLETE - FADE_START);

  return {
    showCompactHeader: scrollY > FADE_START,
    headerOpacity: Math.min(1, scrollProgress * 2),
    scrollProgress,
    showProductInfo: scrollProgress > 0.3,
  };
}
